/* https://stackoverflow.com/questions/64515007/jquery-how-to-marke-touch-and-wheel-event-listeners-as-passive */

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

var thermia = (function ($) {
    "use strict";

    var thermia = {

        timers: [],
        lang: $("html").attr("lang"),

        initSlider: function () {

            var slider = $('.slider-container')

            slider.each(function () {
                var autoplay = $(this).data("autoplay"),
                autoplayDelay = $(this).data("autoplay-delay"),
                fade = $(this).data("fade"),
                autoplaySpeed = 12000;

                if (autoplayDelay !== null && autoplayDelay !== "" && autoplayDelay !== 0) {
                    autoplaySpeed = autoplayDelay;
                }

                $(this).slick({
                    dots: true,
                    infinite: true,
                    speed: fade ? 500 : 300,
                    slidesToShow: 1,
                    adaptiveHeight: true,
                    fade: fade,
                    autoplay: autoplay,
                    autoplaySpeed: autoplaySpeed,
                });
            });

        },

        initTabs: function () {

            $(".product-sub-nav a").click(function () {

                var thisPointer = this,
                    parent = $(this).parent();

                parent.children("a").each(function () {
                    var container = $("#" + $(this).data("container"));

                    
                    if (thisPointer === this) {
                        $(this).addClass("active");
                        container.removeClass("hide");
                        
                    } else {
                        container.addClass("hide");
                        $(this).removeClass("active");
                    }


                });

                $(window).resize();

            });
        },
        initTopBar: function () {
            return;
            function topBarMQ(newSize) {
                if (newSize == ('small' || 'medium')) {
                    $('.top-bar-part-1').addClass('top-bar-left');
                    $('.top-bar-part-2').addClass('top-bar-right');
                    $('.top-bar-part-1').removeClass('top-bar-left');
                    $('.top-bar-part-2').removeClass('top-bar-right');
                }
            }

            $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
                topBarMQ(newSize)
            });
            if (Foundation.MediaQuery.current == ('small' || 'medium')) {
                topBarMQ(Foundation.MediaQuery.current)
            }
        
        },

        delayedWindowEventhandler: function (event, callback) {
            
            var thisPointer = this,
                i = thisPointer.timers.length;
                thisPointer.timers[i] = 0;
           
            $(window).on(event, function (e) {

                if(thisPointer.timers[i]) {
                    window.clearTimeout(thisPointer.timers[i]);
                }

                thisPointer.timers[i] = window.setTimeout(function() {
                    callback(e);
                }, 100);
            });

        },

        initStickyHeader: function () {

            var mypos = $(window).scrollTop(),
                topBar = $('.top-bar'),
                mainMenuItems = $('.main-menu-item');

            function stickyPos(ev) {
 
                /* Dont close if menu is open */
                if (mainMenuItems.hasClass("hover")) {
                    return;
                }

                if (Foundation.MediaQuery.current == ('small' ||  'medium')) {
                    if ($(window).scrollTop() > mypos && $(window).scrollTop() > 69 && ($(document).height() - 69) > $(window).height()) {
                            topBar
                            .removeClass('shown')
                            .addClass('hidden');
                        
                        //$('.top-bar').stop(true).fadeOut("fast");
                    }
                    else {
                        topBar
                            .removeClass('hidden')
                            .addClass('shown');
                        
                        //$('.top-bar').stop(true).fadeIn("fast");
                    }
                } else {

                
                    if ($(window).scrollTop() > mypos && $(window).scrollTop() > 121 && ($(document).height() - 121) > $(window).height()) {
                        topBar
                            .removeClass('shown')
                            .addClass('hidden');
                    }
                    else if ($(window).scrollTop() < mypos) {
                        topBar
                            .removeClass('hidden')
                            .addClass('shown');
                    }

                    if ($(window).scrollTop() > 20 && ($(document).height() - 20) > $(window).height()) {
                        $('.header')
                            .removeClass('desktop-brand-visible')
                            .addClass('desktop-brand-invisible')
                    } else {
                        $('.header')
                            .addClass('desktop-brand-visible')
                            .removeClass('desktop-brand-invisible')
                    }


                }

                mypos = $(window).scrollTop();
            }

            stickyPos();

            this.delayedWindowEventhandler("scroll", function (e) {
                stickyPos(e);
            })

        },

        initStickyFooter: function () {

            function resize() {
                var footerHeight = $('footer').outerHeight();
                var stickFooterPush = $('.push').height(footerHeight);

                $('.wrapper').css({'marginBottom':'-' + footerHeight + 'px'});
            } 

            resize();

            this.delayedWindowEventhandler("resize", function () {
                resize();
            });

        },

        initMobileMenu: function () {


            $('.menu-switch-mobile, .mobile-menu-overlay').on('click', function (event) {
                
                
                $('.mobile-menu-overlay').toggleClass('invisible');
                $('.mobile-menu-overlay').toggleClass('visible');
                $('.main-menu-mobile-wrap').toggleClass('visible');
                
                if ($('.main-menu-mobile-wrap').is('.visible')) {
                    $('body').css('height', '100vh').css('overflow', 'hidden');
                    $(window).trigger('resize');
                } else {
                    $('body').css('height', '').css('overflow', '');
                    $(window).trigger('resize');
                }


            });


        },
        initDesktopMenu: function () {
/*
            var desktopMenuIcons = $('.top-bar-part-2 #menu6, .top-bar-part-2 #menu7, .top-bar-part-2 #menu8');

            desktopMenuIcons.on('show.zf.dropdown',function(){
                $('.top-bar-part-2').addClass('hover-is-icons-desktop');
            });
            desktopMenuIcons.on('hide.zf.dropdown',function(){
                $('.top-bar-part-2').removeClass('hover-is-icons-desktop');
            });
*/
        },
        initEqualizerOnToggle: function () {
            $('.icomoon-info-filled').on('click',function () {
                // $(document).foundation('equalizer', 'reflow');
            })
        },
        initRetailer: function () {

            if(typeof(findRetailerData) === 'undefined') {
                return;
            }


            var retailerMap = (function () {

                "use strict";
                return {
                    loadMarkers: function () {

                        var thisPointer = this,
                            url = findRetailerData.endpoint + "&r=" + Math.random();

                        if (document.getElementById("map-canvas") === null) {
                            return;
                        }


                        $.getJSON(url).success(function (markers) {
                            thisPointer.initMap(markers);
                        });

                    },

                    initMap: function (markers) {

                        //window.location.hash = '<%=strafsearch%>';

                        var findBox = $(".find-box"),
                            mapCanvas = document.getElementById("map-canvas"),
                            address = document.getElementById("address"),
                            af_name = document.getElementById("af-name"),
                            resultDiv = document.getElementById("result-container"),
                            routeInfo = document.getElementById("routeInfo"),
                            imagePath = "/images/retailer";
                         

                        $(address).keyup(function(event){
                            if(event.keyCode == 13){
                                retailers.codeAddress();
                            }
                        });

                        $(af_name).keyup(function(event){
                            if(event.keyCode == 13){
                                retailers.searchName();
                            }
                        });

                        $(".button.search-address").click(function () {
                            retailers.codeAddress();
                        });
                        
                        $(".button.search-name").click(function () {
                            retailers.searchName();                           
                        });

                        $(".button.geolocation").click(function () {
                            retailers.findMyPosition();
                        });

                        if (findRetailerData.showRetailerTypeFilter) {
                            $(".find-box").addClass("show-retailer-type-filter");
                        }


                        $("#retailerType1,#retailerType2,#retailerType3").click(function () {

                            if ($(".search-box li:first-child").hasClass("is-active")) {
                                retailers.codeAddress();
                            } else {
                                retailers.searchName();                           
                            }
                        });


                        retailers.init({
                            markers: markers,
                            mapCanvas: mapCanvas,
                            addressInput: address,
                            initialZoom: findRetailerData.initialZoom,
                            initialPositionLatitude: findRetailerData.initialPositionLatitude,
                            initialPositionLongitude: findRetailerData.initialPositionLongitude,
                            showRetailerTypeFilter: findRetailerData.showRetailerTypeFilter,
                            nameDiv: af_name,
                            resultDiv: resultDiv,
                            routeInfoDiv: routeInfo,
                            showRoomMarker: imagePath + '/thermia_pin_center_small.png',
                            noShowRoomMarker: imagePath + '/thermia_pin_small.png',
                            distanceIcon: imagePath + '/ico_aim.png',
                            routeIcon: imagePath + '/ico_car.png',
                            phoneIcon: imagePath + '/ico_phone.png',
                            cluster: false,
                            imagePath: imagePath,
                            country: findRetailerData.country,
                            updateResultCallback: function (markers) {
                                const retailerBox = findBox.parents(".retailer");

                                if (markers.length === 0) {
                                    retailerBox.removeClass("shows-result");

                                } else {
                                    retailerBox.addClass("shows-result");
                                }
                            }
                        }, 
                        markers);

                    }

                };

            }());


            retailerMap.loadMarkers();
            
        },

        initQAFilter: function () {

            var filters = $(".qa-filter").click(function() {

                var currentFilters = $(".qa-filter:checked"),
                    allQuestions = $(".question-container .accordion-item");

                if (currentFilters.length === 0) {
                    allQuestions.show();
                    return;
                } else {
                    allQuestions.hide();
                }

                currentFilters.each(function () {

                    var filterKey = $(this).data("filter-key");

                    allQuestions = allQuestions.filter('[data-filter*="' + filterKey + '"]');

                });

                allQuestions.show();

            });

        },
        initBlickLinks: function () {
            $("[data-href]").click(function () {
                window.top.location = $(this).data("href");
            });
        },
        initSearch: function() {
            $(".dropdown-pane.search [type=search]").keypress(function (event) {

                var searchUrl = $(this).data("search-url");

                if (event.keyCode === 13) {
                    if ($(this).val().length > 0) {
                        window.location.href = searchUrl + "?keywords=" + $(".search input[type='search']").val();
                    } else {
                        alert("Search Box is Empty");
                    }
                }

            });
        },

        initForms: function () {

            $(document).on("keydown", ".cta-form :input:not(textarea)", function(event) {
                return event.key != "Enter";
            });

            $(".cta-form-container .form-pagination").click(function () {

                var parent = $(this).closest('.cta-form-container'),
                    step_counter = parent.find(".step_counter"),
                    formElem = parent.find(".cta-form"),
                    formName = formElem.find("input[name='form']").val(),
                    formInputs = formElem.find(".step input, .step select"),
                    counterDirection = $(this).hasClass("next") ? 1 : -1,
                    currentStep = parseInt(step_counter.html()),
                    nextButton = parent.find(".form-pagination-container .next"),
                    prevButton = parent.find(".form-pagination-container .prev"),
                    sendButton = parent.find(".form-pagination-container .send")

                var currentStepElem = parent.find(".step-" + currentStep);

                var next_step = currentStep + counterDirection;
                var steps = parent.find(".step");

                formInputs.prop( "disabled", true );
                currentStepElem.find("input, select").prop( "disabled", false );
                //console.log(currentStepElem, formInputs, formElem[0].checkValidity());

                if(counterDirection === 1) {
                    if (!formElem[0].checkValidity()) {
                        // If the form is invalid, submit it. The form won't actually submit;
                        // this will just cause the browser to display the native HTML5 error messages.
                        formElem.find(':submit').click();
                        return;
                    }
                }

                console.log(steps.length, next_step);

                window.dataLayer.push({
                  'form': formName,
                  'step': next_step,
                  'event': 'form-pagination'
                });


                if (steps.length >= next_step) { /* next step */

                    steps.hide();

                    var nextStep = parent.find(".step-" + next_step);

                    nextStep.find("input, select").prop( "disabled", false );

                    step_counter.html(next_step);

                    nextStep.show();

                    //console.log(nextStep);

                    $(this).data("current-step", next_step);

                    if (steps.length === next_step) { /* last step */
                        formInputs.prop( "disabled", false );

                        nextButton.hide();
                        sendButton.show();
                    } else if (1 === next_step) {
                        nextButton.show();
                        prevButton.hide();
                    } else {
                        nextButton.show();
                        prevButton.show();
                        sendButton.hide();
                    }   

                }


            });


            $(".cta-form").submit(function(event) {

                event.preventDefault();

                var form = $(this),
                    thanksMsg = form.data("thanks-msg"),
                    thanksPopup = form.data("thanks-popup"),
                    url = form.data('action'),
                    formData = form.serializeArray(),
                    tag = form.data("tag"),
                    submitButton = form.find("input[type='submit']");

                submitButton.prop( "disabled", true );

                if (tag !== undefined && tag !== "") {
                    jQuery.each( formData, function( i, formField ) {
                        if (formField.name === 'namn') {
                            formData[i].value = formData[i].value + " (" + tag + ")";
                        }    
                    });
                }

                $.ajax({
                    url: url,
                    type: 'POST',
                    data: $.param(formData),
                    success: function(result) {
                        
                        if(thanksPopup) {
                            var popup = new Foundation.Reveal($('<div class="reveal text-center">' + thanksMsg + '<button class="close-button" data-close aria-label="Close modal" type="button"><span aria-hidden="true">&times;</span></button></div>'));
                            popup.open();
                            form.closest(".cta-form-container").html("");   

                        } else {
                            form.closest(".cta-form-container").html(thanksMsg);
                        }

                    }
                });

            });

            $(".vp-book-selector, input[type=radio][name=vp-book-selector]").change(function () {

                var value = $(this).val(),
                    container = $(this).parent().parent(),
                    pdfForm = container.find(".vp-book-pdf"),
                    orderForm = container.find(".vp-book-order");

                if (value === "pdf") {
                    pdfForm.removeClass("hide");
                    orderForm.addClass("hide");
                } else if (value == "order") {
                    pdfForm.addClass("hide");
                    orderForm.removeClass("hide");
                }
            });

        },
        initCTABlock: function () {

            $(".button.has-cta-form").click(function (event) {
                $(this).closest(".columns").find(".cta-form-container").slideToggle();
                event.preventDefault();
                return false;
            });

        },
        initCampaign: function () {
            $(".fold-out-button").click(function () {
                var campaignBlock = $(this).parent(),
                    foldout = campaignBlock.find(".fold-out");
                
                if(campaignBlock.hasClass("open")) {
                    foldout.slideUp();
                } else {
                    foldout.slideDown();
                }
                
                $(campaignBlock).toggleClass("open");
                
            });

        },
        initCalculator: function () {
            
            var euro = this.lang == "fi" ? true : false;

            if ($("#calculator").length > 0) {
            
                $.getScript("/scripts/calculator/jquery-ui.js", function() {

                    $("#calculator").thermiacalculator({
                        oilPrice: euro ? 1100 : 11000,
                        electricityPrice: euro ? 12.5 : 125,
                        allowUserToSetConsumption: false,
                        allowUserToSetCost: true
                    });
                });
            }

        },

        setCookie: function(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie: function (cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        initCookiebar: function () {
            //this.setCookie("cookie-bar", "", 365);
            var thisPointer = this;
            if (this.getCookie("cookie-bar") === "") {
                
                $('.cookie-bar').slideDown();
                $('.cookie-bar .button.agree').click(function (event) {

                    $('.cookie-bar').slideUp();
                    thisPointer.setCookie("cookie-bar", "hide", 365);

                    event.preventDefault();
                    return false;
                });
                
            }

        },
        initYouTube: function () {
            window.addEventListener('CookiebotOnConsentReady', function () {
                if (!Cookiebot.consent.marketing) { return; }

                var youtube = document.querySelectorAll(".youtube");

                for (var i = 0; i < youtube.length; i++) {
                    if (youtube[i].dataset.loaded) { continue; }
                    youtube[i].dataset.loaded = true;

                    var source = "https://img.youtube.com/vi/" + youtube[i].dataset.embed + "/maxresdefault.jpg";

                    var image = new Image();
                    image.src = source;
                    image.addEventListener("load", function () {
                        youtube[i].appendChild(image);
                    }(i));

                    youtube[i].addEventListener("click", function () {
                        var iframe = document.createElement("iframe");

                        iframe.setAttribute("frameborder", "0");
                        iframe.setAttribute("width", "100%");
                        iframe.setAttribute("allowfullscreen", "");
                        iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
                        iframe.setAttribute("src", "https://www.youtube-nocookie.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");

                        this.appendChild(iframe);
                    });
                };
            });
        },
        init: function () {
            this.initCookiebar();

            this.initTopBar();
            this.initSlider();
            this.initStickyHeader();
            //this.initStickyFooter();
            this.initMobileMenu();
            this.initDesktopMenu();
            this.initTabs();
            this.initEqualizerOnToggle();


            this.initRetailer();
            this.initQAFilter();
            this.initBlickLinks();
            this.initSearch();
            this.initForms();
            this.initCTABlock();

            this.initCampaign();
            this.initCalculator();

            this.initYouTube();
        }
    };


    return thermia;

}(jQuery));

$(document).foundation();
    
$(function() {
    thermia.init();
});

$(window).load(function() { 
    $(window).resize();
});
